// extracted by mini-css-extract-plugin
export default {"tabs":"ContentTabs_tabs__YYx0X"};